import { deleteApi, get, post } from "../GenericServices";

const CarEngineType = {
  getCarEngineTypes: (queryString) => {
    return get(`car-engine-type${queryString !== "" ? `?${queryString}` : ""}`);
  },
  getCarEngineType: (id) => {
    return get(`car-engine-type/${id}`);
  },
  setCarEngineType: (data) => {
    return post(`car-engine-type`, data);
  },
  deleteCarEngineType: (id) => {
    return deleteApi(`car-engine-type/${id}`);
  },
};

export default CarEngineType;
